import type { Key } from 'react-aria';
import type { GroupFilter, MetricFilter } from '@gonfalon/metrics/types';

export const updateSubFilter = (
  updateFunction: (f: MetricFilter) => void,
  parentFilter: GroupFilter,
  updatedSubFilter: MetricFilter,
  index: number,
) => {
  updateFunction({
    ...parentFilter,
    values: parentFilter.values.map((v, i) => (i === index ? updatedSubFilter : v)),
  });
};

export const removeSubFilter = (
  updateFunction: (f: MetricFilter) => void,
  parentFilter: GroupFilter,
  index: number,
) => {
  const newFilters = [...parentFilter.values];
  newFilters.splice(index, 1);
  if (newFilters.length === 1) {
    updateFunction(newFilters[0]);
  } else {
    updateFunction({ ...parentFilter, values: newFilters });
  }
};

export const addFilter = (
  updateFunction: (f: MetricFilter) => void,
  filterToAddTo: MetricFilter,
  chosenFilterToAdd: MetricFilter,
) => {
  const updatedFilter =
    filterToAddTo.type === 'group'
      ? {
          ...filterToAddTo,
          values: [...filterToAddTo.values, chosenFilterToAdd] as MetricFilter[],
          negate: false as const,
        }
      : {
          type: 'group' as const,
          op: 'and' as const,
          values: [filterToAddTo, chosenFilterToAdd],
          negate: false as const,
        };

  updateFunction(updatedFilter);
};

export const handleAddSubFilter = (
  onUpdate: (f: MetricFilter) => void,
  parentFilter: GroupFilter,
  index: number,
  currentFilter: MetricFilter,
  newFilter: MetricFilter,
) => {
  const updatedSubFilter =
    currentFilter.type === 'group'
      ? { ...currentFilter, values: [...currentFilter.values, newFilter] as MetricFilter[], negate: false as const }
      : {
          type: 'group' as const,
          op: 'and' as const,
          values: [currentFilter, newFilter],
          negate: false as const,
        };

  updateSubFilter(onUpdate, parentFilter, updatedSubFilter, index);
};

export const handleOpChange = (onUpdate: (f: MetricFilter) => void, parentFilter: MetricFilter, keys: Set<Key>) => {
  const [key] = Array.from(keys);
  if (key === 'and' || key === 'or') {
    onUpdate({ ...parentFilter, op: key });
  }
};

export const validateFilter = (filter?: MetricFilter): boolean => {
  if (!filter) {
    return true;
  }
  if (filter.type === 'group') {
    return filter.values.every((v) => validateFilter(v));
  } else {
    return Boolean(filter.attribute && filter.values && filter.values.length > 0);
  }
};
